import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "86",
  height: "85",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M73.267 78.485a22.6 22.6 0 0 0 5.718-5.718C83 66.967 83 58.81 83 42.5c0-16.31 0-24.466-4.015-30.267a22.6 22.6 0 0 0-5.718-5.718C67.467 2.5 59.31 2.5 43 2.5c-16.31 0-24.466 0-30.267 4.015a22.6 22.6 0 0 0-5.718 5.718M65.23 81.56c-2.55.46-5.514.695-9.054.815m-10.352.125L43 82.5c-4.09 0-7.667 0-10.824-.063m-13.647-1.37c-2.225-.587-4.11-1.415-5.796-2.582a22.6 22.6 0 0 1-5.718-5.718c-.896-1.294-1.592-2.706-2.133-4.3M3.073 53.795C3 50.524 3 46.794 3 42.5s0-8.024.073-11.294"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "m34 42 7.648 10.348a1 1 0 0 0 1.64-.044L56 33"
    }, null, -1)
  ])))
}
export default { render: render }